import React from 'react'
import {observer} from 'mobx-react'
import PropTypes from 'prop-types';
import ConditionalComponent from "../../Shared/ConditionalComponent";
import {useStores} from "../../../Hooks";
import {getProcedureText} from "../../../serverClientShared/sharedUtils";

const ProcedureIntro = observer(props => {
    const {procedureStore, generalStore} = useStores();


    const isPreview = props.isPreview;
    const {
        currentNode,
        currentProcedure,
        totalSteps: currentTotalSteps,
        currentPreviewedNode,
        currentPreviewedProcedure,
        previewedTotalSteps
    } = procedureStore;
    const node = (isPreview ? currentPreviewedNode : currentNode) || {};
    const procedure = isPreview ? currentPreviewedProcedure : currentProcedure;
    const totalSteps = isPreview ? previewedTotalSteps : currentTotalSteps;
    return (
        <div className="procedure-intro-container">
            <div className="procedure-intro-header intro-procedure-title">{procedure.ProcedureName}</div>
            <ConditionalComponent if={!!getProcedureText(node, "StepHeader", procedure)}>
                <div className="node-title" dangerouslySetInnerHTML={{__html: getProcedureText(node, "StepHeader", procedure)}}/>
            </ConditionalComponent>

            <div className="procedure-steps-summary">
                {totalSteps > 0 ? totalSteps : 0} {generalStore.translate(totalSteps === 1 ? "step" : "steps")}
            </div>
        </div>
    )
});

ProcedureIntro.propTypes = {
    isPreview: PropTypes.bool.isRequired
}

export default ProcedureIntro
